import { useRequiredActiveOrg } from '~/hooks/org'

export const useKycStatus = () => {
  const org = useRequiredActiveOrg()

  if (!org.bridge?.kyc.kycStatus) {
    return {
      isKycComplete: false,
      isKycPending: false,
      isKycRejected: false,
      isKycStarted: false,
    }
  }

  const tosApproved = org.bridge.kyc.tosStatus === 'approved'
  const kycApproved = org.bridge.kyc.kycStatus === 'approved'
  const isKycComplete = tosApproved && kycApproved
  const isKycRejected = org.bridge.kyc.kycStatus === 'rejected'
  const isKycPending = !isKycComplete && !isKycRejected

  return {
    isKycComplete,
    isKycPending,
    isKycRejected,
    isKycStarted: isKycComplete || isKycPending || isKycRejected,
  }
}
